import { headerConnect as connect } from 'components/Shared/connect';
import { CartItem } from 'models/CartItem';
import { AppearanceTypes } from 'components/Shared/Button';
import { Relation } from 'models/Relation';
import { CheckoutProduct, RelationSubItem } from './CheckoutProduct';
import { useToggle } from '@bygghemmait/hooks';
import { useSelector } from 'react-redux';
import { getBobSubItemRelations } from 'components/Cart/selector';
import { selectShouldUseNewCart } from '../DeliveryInformation/selector';

interface OwnProps {
  appearance?: AppearanceTypes;
  className?: string;
  removed?: boolean;
}

interface MergedProps extends OwnProps {
  items: CartItem[];
  subItemRelations: { [key: string]: Relation };
}

const CheckoutProducts = ({ items, subItemRelations }: MergedProps) => {
  const [shouldBeDisabled, setShouldBeDisabled] = useToggle(false);
  const shouldUseNewCart = useSelector(selectShouldUseNewCart);
  const bobSubItemRelations = useSelector(getBobSubItemRelations);

  if (shouldUseNewCart && bobSubItemRelations) {
    return (
      <div>
        {items.map(item => {
          const bobRelation = bobSubItemRelations?.filter(
            itemRelationResponse => itemRelationResponse.key === item.cartItemId
          ).map(item => item.value);

          const bobRelationsWithType: RelationSubItem[] | undefined = bobRelation?.flatMap(
            relation => relation.items.map(item => ({ ...item, itemType: relation.type })));

          return (
            <CheckoutProduct
              key={item.cartItemId}
              item={item}
              relations={bobRelationsWithType || []}
              shouldBeDisabled={shouldBeDisabled}
              setShouldBeDisabled={setShouldBeDisabled}
            />
          );
        })}
      </div>
    );
  }

  return (
    <div>
      {items.map(item => (
        <CheckoutProduct
          key={item.cartItemId}
          item={item}
          relations={subItemRelations[item.cartItemId]?.items ?? []}
          shouldBeDisabled={shouldBeDisabled}
          setShouldBeDisabled={setShouldBeDisabled}
        />
      ))}
    </div>
  );
};

export default connect<MergedProps, OwnProps>(state => ({
  items: state.cart.cartItems,
  subItemRelations: state.cart.subItemRelations
}))(CheckoutProducts);
